import Component from "../../../lib/component";
import stateMachine from "../instances/deals_widget_state_machine";

/**
 * Base class for deals widget sub-components.
 * All sub-components share the same state machine instance,
 * so when ANY component dispatches an action, ALL components auto-render.
 */
export default class DealsWidgetBase extends Component {
  constructor(element, parentComponent, config) {
    super({
      element,
      config,
      stateMachine,
    });

    this.parentComponent = parentComponent;
  }
}
